module.exports = __webpack_public_path__ + "img/ck.0433a99d.jpg";